module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"date":"Date","time":"Time","timeNotSet":"Time is a mandatory field","invalidDateObject":"Invalid date","date1IsNotBeforeDate2":"Planned departure is before planned arrival."},"no":{"date":"Dato","time":"Tid","timeNotSet":"Tidspunkt er påkrevd","invalidDateObject":"Ugyldig dato","date1IsNotBeforeDate2":"Planlagt avgang er før planlagt ankomst."}}')
  delete Component.options._Ctor
}
